import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Box,
  ButtonStyled,
  HeadingStyled,
  TextStyled,
} from "../../../../components/styled/Elements";
import { AuthContext } from "../../../../context/authContext";
import { requireAuthNavigate } from "../../../../utils";
import { LeadFormWrapper } from "./style";

/**
 * @returns {boolean} true when the fillable inquiry form may render.
 */
export const useInquiryAuthGate = () => {
  const { isAuthenticated } = useContext(AuthContext);
  return isAuthenticated;
};

/** Shown instead of the inquiry form when the visitor is not logged in. */
const InquiryLoginRequired = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated } = useContext(AuthContext);

  const handleLogin = () => {
    requireAuthNavigate(
      navigate,
      isAuthenticated,
      `${location.pathname}${location.search}`
    );
  };

  return (
    <LeadFormWrapper>
      <Box className="py-4 px-2 text-center">
        <HeadingStyled size="18px" className="mb-2">
          {t("login_to_submit_request")}
        </HeadingStyled>
        <TextStyled size="14px" color="var(--lightGrey)" className="mb-3">
          {t("login_to_submit_request_hint")}
        </TextStyled>
        <ButtonStyled
          label={t("login")}
          bg="var(--themeColorSecondary)"
          color="var(--white)"
          className="w-100"
          onClick={handleLogin}
        />
      </Box>
    </LeadFormWrapper>
  );
};

export default InquiryLoginRequired;
